import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Necesito experiencia previa?',
    a: 'No, el curso está diseñado para principiantes. Te guiamos paso a paso desde lo más básico hasta técnicas avanzadas, asegurando que logres resultados increíbles desde tu primer intento.'
  }, {
    q: '¿Qué materiales necesito?',
    a: 'Te proporcionamos una lista completa y detallada dentro del curso. Empezaremos con materiales básicos y accesibles que puedes conseguir fácilmente, y te daremos opciones de proveedores.'
  }, {
    q: '¿Puedo vender lo que cree?',
    a: '¡Por supuesto! Muchas de nuestras alumnas han iniciado su propio negocio exitoso. El curso incluye un módulo especial de emprendimiento y tips de presentación para que tus productos luzcan premium.'
  }, {
    q: '¿Es 100% online?',
    a: 'Sí, puedes acceder a todas las lecciones en video y materiales descargables desde cualquier dispositivo (celular, tablet o computadora) a tu propio ritmo y en el horario que prefieras.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 bg-artisanal-beige" data-id="element-26">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-27">
        <div className="text-center mb-12" data-id="element-28">
          <h2 className="font-serif text-3xl md:text-4xl text-artisanal-brown font-bold mb-4" data-id="element-29">
            Preguntas Frecuentes
          </h2>
        </div>

        <div className="space-y-4" data-id="element-30">
          {faqs.map((faq, index) => <div key={index} className="bg-white rounded-2xl overflow-hidden shadow-sm border border-artisanal-cream" data-id="element-31">
              <button className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-32">
                <span className="font-serif font-bold text-artisanal-brown text-lg" data-id="element-33">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-artisanal-terracotta transition-transform duration-300 ${openIndex === index ? 'transform rotate-180' : ''}`} data-id="element-34" />
              </button>
              <AnimatePresence data-id="element-35">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-36">
                    <div className="px-6 pb-5 pt-0 text-artisanal-brown/80 font-sans" data-id="element-37">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}